import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withContent from '../../../../containers/withContent';
import { withScrollTop } from '../../../../containers/withScrollTop';
import {
	getBacsDetailsWithAccounts,
	getBacsDeadlineMissed,
	getRequiresAuthorisation,
	getBacsCreditAuthorisers,
	getBacsCreditIsDefaultAuthorisers,
	isInternalTransferOrCCPayment,
} from '../../../../states/bacsCredit/selectors';
import { hasApiCallInProgress } from '../../../../states/api/selectors';
import creditReviewContent, { contentPropTypes } from './CreditReview.content';
import CreditSummary from '../../BacsSummary/CreditSummary/CreditSummary';
import CreditDeadlineMissed from './CreditDeadlineMissed';
import CreditTable from '../../BacsTable/CreditTable/CreditTable';
import BacsReview from '../BacsReview';
import CreditAuthoriserViewer from './CreditAuthoriserViewer';
import CreditAuthoriserSelector from './CreditAuthoriserSelector';
import { goToPage, pages } from '../../../../states/page/actions';
import { hasGroupApprovalsEnabled } from '../../../../states/modes/selectors';
import { getUserId } from '../../../../states/user/selectors';

const mapState = (state) => ({
	bacsDetails: getBacsDetailsWithAccounts(state),
	hasApiCallInProgress: hasApiCallInProgress(state),
	hasGroupApprovalsEnabled: hasGroupApprovalsEnabled(state),
	deadlineMissed: getBacsDeadlineMissed(state),
	authRequired: getRequiresAuthorisation(state),
	authorisers: getBacsCreditAuthorisers(state),
	isDefaultAuthorisers: getBacsCreditIsDefaultAuthorisers(state),
	isTransferOrCCPayment: isInternalTransferOrCCPayment(state),
	userId: getUserId(state),
});

const mapDispatch = (dispatch) => ({
	navigateToEffectiveWarningPage: (page) => dispatch(goToPage(page)),
});

class CreditReviewPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = { showAuthModal: false };
		this.handleContinue = this.handleContinue.bind(this);
	}

	handleContinue() {
		const { navigateToEffectiveWarningPage, isTransferOrCCPayment, handleContinue } = this.props;
		if (isTransferOrCCPayment) return handleContinue();
		return navigateToEffectiveWarningPage(pages.EffectiveWarning.paymentReason);
	}

	render() {
		const {
			content,
			hasApiCallInProgress,
			bacsDetails,
			deadlineMissed,
			handleRoute,
			authRequired,
			handleBack,
			handlePaymentInReview,
			hasGroupApprovalsEnabled,
			authorisers,
			isDefaultAuthorisers,
			userId,
		} = this.props;

		const renderSummary = () => <CreditSummary />;
		const renderTable = () => <CreditTable />;
		const renderDeadlineMissed = () => <CreditDeadlineMissed content={content} handleRoute={handleRoute} />;
		return (
			<div>
				<BacsReview
					content={content}
					renderBacsSummary={renderSummary}
					handleContinue={this.handleContinue}
					handleBack={handleBack}
					renderBacsTable={renderTable}
					renderDeadlineMissed={renderDeadlineMissed}
					hasApiCallInProgress={hasApiCallInProgress}
					bacsDetails={bacsDetails}
					deadlineMissed={deadlineMissed}
					authRequired={authRequired}
					handlePaymentInReview={handlePaymentInReview}
					openAuthoriserModal={() => this.setState({ showAuthModal: true })}
					authorisers={authorisers}
					isDefaultAuthorisers={isDefaultAuthorisers}
					userId={userId}
					hasGroupApprovalsEnabled={hasGroupApprovalsEnabled}
				/>

				{hasGroupApprovalsEnabled ? (
					<CreditAuthoriserViewer
						isOpen={this.state.showAuthModal}
						onClose={() => this.setState({ showAuthModal: false })}
					/>
				) : (
					<CreditAuthoriserSelector
						isOpen={this.state.showAuthModal}
						onClose={() => this.setState({ showAuthModal: false })}
					/>
				)}
			</div>
		);
	}
}

CreditReviewPage.propTypes = {
	bacsDetails: PropTypes.shape({}).isRequired,
	content: PropTypes.shape(contentPropTypes).isRequired,
	handleContinue: PropTypes.func.isRequired,
	hasApiCallInProgress: PropTypes.bool.isRequired,
	handleBack: PropTypes.func.isRequired,
	deadlineMissed: PropTypes.bool,
	handleRoute: PropTypes.func.isRequired,
	authRequired: PropTypes.bool.isRequired,
	handlePaymentInReview: PropTypes.func.isRequired,
	authorisers: PropTypes.arrayOf(PropTypes.shape({})),
	isDefaultAuthorisers: PropTypes.bool,
	navigateToEffectiveWarningPage: PropTypes.func,
	isTransferOrCCPayment: PropTypes.bool,
};

CreditReviewPage.defaultProps = {
	authorisers: [],
};

export const ConnectWrapper = connect(mapState)(CreditReviewPage);
const contentWrapper = withContent({ content: creditReviewContent });
export default compose(connect(mapState, mapDispatch), contentWrapper, withScrollTop)(CreditReviewPage);
